import { Component, Input, input } from '@angular/core';
import { IconNames } from '@shared/enums/icon-names';
import { MatIcon } from '@angular/material/icon';
import { NgClass } from '@angular/common';

@Component({
  selector: 'app-small-card-button',
  templateUrl: './small-card-button.component.html',
  styleUrls: ['./small-card-button.component.scss'],
  imports: [NgClass, MatIcon],
})
export class SmallCardButtonComponent {
  IconNames = IconNames;

  testId = input.required<string>();
  @Input() iconName: string;
  @Input() name: string;
  @Input() isDisabled: boolean;
  @Input() tab: number = 0;
}
